import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54efbb62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "tags"
}

import { Ref, computed, nextTick, reactive, ref } from 'vue';
import { DeleteFilled } from '@element-plus/icons-vue';
import {
  BaseButton,
  BaseButtonProps,
  BaseCascader,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseIcon,
  BaseInput,
  BaseSelect,
  XrkMessage,
  createDialog,
  BaseTextContent
} from 'xrk-components';
import { TagType } from '../data-source/types';
import { useProvince } from '../hooks/use-province';
import { useZsStore } from '../store';
import { getTagList, addTag, updateTag, deleteTag } from '../data-source/api';
import {
  TAG_SOURCE_SYSTEM,
  TAG_SOURCE_CUSTOM,
  OPTION_TYPE_RADIO,
  OPTION_TYPE
} from '../config/index';

const MAX_TAG_COUNT = 20;
const MAX_TAG_VALUE_COUNT = 50;
const MAX_TAG_VALUE_LENGTH = 20;

export default /*#__PURE__*/_defineComponent({
  __name: 'zs-manage-ability',
  setup(__props) {

const dealTagValue = (val: any) => {
  console.log(val);
  return typeof val === 'string'
    ? `${val}`.replace(/[^\u4e00-\u9fa5a-z\d-/]+/i, '')
    : val;
};

const { isOwnPublish, enterpriseId } = useZsStore();
const { addressData } = useProvince();

const tags = ref<Array<TagType>>([]);

const initData = async () => {
  const { data } = await getTagList({ enterpriseId: enterpriseId.value });
  tags.value = data;
};

initData();

const confirmBtnConfig = {
  show: true,
  type: 'primary',
  content: '保存'
} as BaseButtonProps;
const cancelBtnConfig = {
  show: true,
  type: 'default',
  content: '取消'
} as BaseButtonProps;

const topTagValues = computed(() => tags.value.map(i => i.name));
// const subTagValues = computed(() =>
//   tags.value.reduce((pre, cur) => {
//     pre.push(...(cur.childList?.map(i => i.name) || []));
//     return pre;
//   }, [] as Array<string>)
// );

const createTagValueInput = (
  FormRef: Ref<BaseFormRef>,
  formData: any,
  childs: Array<any>,
  tagValues: Array<{ prop: string; label: string }>,
  minCount = 1
) => {
  return (
    <>
      {tagValues.map(({ prop }, index) => {
        const title = `标签值${index + 1}`;
        return (
          <BaseFormItem
            prop={prop}
            label={title}
            rules={{
              required: true,
              validator: (_, value, callabck) => {
                if (!value) return callabck(`请输入标签值`);
                const allCommonValues = [
                  ...tagValues.map(i => i.label),
                  ...(childs || []).map(i => i.name)
                ];
                if (allCommonValues.filter(text => text == value).length > 1)
                  return callabck('标签值已存在');
                callabck();
              }
            }}
          >
            <div style="width:100%;display:flex;gap:16px;align-items:center">
              <BaseInput
                style="flex:1"
                modelValue={formData[prop]}
                onBlur={() => FormRef.value.validate()}
                onInput={val => {
                  tagValues[index].label = formData[prop] = dealTagValue(val);
                }}
                placeholder={`请输入标签值`}
                maxlength={MAX_TAG_VALUE_LENGTH}
                showWordLimit
              ></BaseInput>
              <BaseIcon
                size={20}
                style={
                  tagValues.length <= minCount
                    ? { opacity: 0.4 }
                    : { cursor: 'pointer' }
                }
              >
                <DeleteFilled
                  onClick={() => {
                    if (tagValues.length <= minCount) return;
                    tagValues.splice(index, 1);
                    delete formData[prop];
                    nextTick(() => FormRef.value.validate());
                  }}
                ></DeleteFilled>
              </BaseIcon>
            </div>
          </BaseFormItem>
        );
      })}
      {(childs?.length || 0) + tagValues.length < MAX_TAG_VALUE_COUNT && (
        <BaseFormItem style="margin-bottom:0;" label={' '} prop={'operate'}>
          <BaseButton
            type="text"
            onClick={() => {
              const prop = `tag-value-${Date.now()}-${Math.random().toFixed(
                5
              )}`;
              tagValues.push({
                label: '',
                prop: prop
              });
              nextTick(() => FormRef.value.scrollToField(prop));
            }}
          >
            新增选项
          </BaseButton>
        </BaseFormItem>
      )}
    </>
  );
};

const createTagDialog = (row: Partial<TagType>, isAdd: boolean) => {
  const FormRef = ref<BaseFormRef>();
  const tagValues = reactive(
    row.childList?.length < MAX_TAG_VALUE_COUNT || isAdd
      ? [{ label: '', prop: `tag-value-1` }]
      : []
  );
  const formData = reactive({ ...row, label: row.name });
  const isUsed = row.allowDelete == 1;
  createDialog({
    width: 450,
    title: isAdd ? '新增自定义标签' : '编辑自定义标签',
    contentRender: () => (
      <BaseTextContent>
        <BaseForm model={formData} ref={FormRef}>
          <BaseFormItem
            prop="optionType"
            label="标签类型"
            rules={{
              required: true,
              validator: (_, value, callabck) => {
                if (!value) return callabck(`请选择自定义标签类型`);
                callabck();
              }
            }}
          >
            <BaseSelect
              disabled={isUsed}
              modelValue={formData.optionType}
              style="width:100%;"
              options={OPTION_TYPE}
              placeholder="请选择自定义标签类型"
              onChange={(val: any) => {
                formData['optionType'] = val;
              }}
            ></BaseSelect>
          </BaseFormItem>
          <BaseFormItem
            prop="label"
            label="标签名称"
            rules={{
              required: true,
              validator: (_, value, callabck) => {
                if (!value) return callabck(`请输入标签名称`);
                const allCommonValues = [...topTagValues.value];
                if (isAdd) {
                  allCommonValues.push(formData.label);
                }
                if (allCommonValues.filter(text => text == value).length > 1)
                  return callabck('标签名称已存在');
                callabck();
              }
            }}
          >
            <BaseInput
              style="width:100%;"
              disabled={isUsed}
              modelValue={formData['label']}
              onBlur={() => FormRef.value.validateField(['label'])}
              onInput={(val: string) => (formData['label'] = val)}
              placeholder={`请输入自定义能力标签名称(${MAX_TAG_VALUE_LENGTH}汉字长度)`}
              maxlength={MAX_TAG_VALUE_LENGTH}
              showWordLimit
            ></BaseInput>
          </BaseFormItem>
          {createTagValueInput(
            FormRef,
            formData,
            row.childList,
            tagValues,
            isAdd ? 1 : 0
          )}
        </BaseForm>
      </BaseTextContent>
    ),
    showClose: true,
    showFooter:
      isAdd ||
      row.childList?.length < MAX_TAG_VALUE_COUNT ||
      row?.allowDelete != 1,
    confirmBtnConfig: confirmBtnConfig,
    cancelBtnConfig: cancelBtnConfig,
    beforeConfirm: async done => {
      await FormRef.value.validate();
      if (isAdd) {
        await addTag({
          enterpriseId: enterpriseId.value,
          name: formData['label'],
          childLabelList: tagValues.map(({ prop }) => formData[prop]),
          optionType: formData['optionType']
        });
      } else {
        await updateTag({
          enterpriseId: enterpriseId.value,
          id: row.id,
          name: formData['label'],
          childLabelList: tagValues.map(({ prop }) => formData[prop]),
          optionType: formData['optionType']
        });
      }
      XrkMessage.success('操作成功');
      initData();
      done();
    }
  });
};

const createTagValueDialog = (row: Partial<TagType>) => {
  const FormRef = ref<BaseFormRef>();
  const formData = reactive({});
  const tagValues = reactive(
    row.childList.length < MAX_TAG_VALUE_COUNT
      ? [{ label: '', prop: `tag-value-1` }]
      : []
  );
  createDialog({
    width: 450,
    title: '新增标签值',
    contentRender: () => (
      <BaseTextContent>
        <BaseForm model={formData} ref={FormRef}>
          <BaseFormItem prop="name" label="标签名称">
            <BaseInput
              style="width:100%;"
              disabled
              modelValue={row['name']}
            ></BaseInput>
          </BaseFormItem>
          {createTagValueInput(FormRef, formData, row.childList, tagValues)}
        </BaseForm>
      </BaseTextContent>
    ),
    showClose: true,
    showFooter:
      row.childList.length < MAX_TAG_VALUE_COUNT || row.allowDelete != 1,
    confirmBtnConfig: confirmBtnConfig,
    cancelBtnConfig: cancelBtnConfig,
    beforeConfirm: async done => {
      await FormRef.value.validate();
      await updateTag({
        enterpriseId: enterpriseId.value,
        id: row.id,
        name: row.name,
        childLabelList: tagValues.map(({ prop }) => formData[prop]),
        optionType: formData['optionType']
      });
      initData();
      done();
    }
  });
};

const onTagDel = (index: number) => {
  createDialog({
    width: 350,
    title: '提示',
    contentRender: () => (
      <BaseTextContent>
        <p style={{ textAlign: 'center' }}>是否删除自定义标签</p>
      </BaseTextContent>
    ),
    beforeConfirm: async done => {
      try {
        await deleteTag({ id: tags.value[index].id });
        tags.value.splice(index, 1);
      } catch (error) {
        console.warn(error);
      } finally {
        done();
      }
    }
  });
};

const onTagValueDel = (tagChilds: TagType['childList'], index: number) => {
  createDialog({
    width: 350,
    title: '提示',
    contentRender: () => (
      <BaseTextContent>
        <p style={{ textAlign: 'center' }}>是否删除标签值</p>
      </BaseTextContent>
    ),
    beforeConfirm: async done => {
      try {
        await deleteTag({ id: tagChilds[index].id });
        tagChilds.splice(index, 1);
      } catch (error) {
        console.warn(error);
      } finally {
        done();
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isOwnPublish))
      ? (_openBlock(), _createBlock(_unref(BaseButton), {
          key: 0,
          type: "primary2",
          onClick: _cache[0] || (_cache[0] = () => createTagDialog({}, true)),
          disabled: tags.value.length >= MAX_TAG_COUNT
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 新增自定义标签 ")
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(`${item.name}${
              item.source !== _unref(TAG_SOURCE_SYSTEM)
                ? item.optionType == _unref(OPTION_TYPE_RADIO)
                  ? '（单选）'
                  : '（多选）'
                : ''
            }`), 1),
          (_unref(isOwnPublish))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (item.source === _unref(TAG_SOURCE_SYSTEM) && !item.isLocation)
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 0,
                      size: "small",
                      onClick: () => createTagValueDialog(item),
                      disabled: item.childList.length >= MAX_TAG_VALUE_COUNT
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 新增标签值 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]))
                  : _createCommentVNode("", true),
                (item.source === _unref(TAG_SOURCE_CUSTOM))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(BaseButton), {
                        type: "primary",
                        onClick: ($event: any) => (createTagDialog(item, false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 编辑 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_unref(BaseButton), {
                        type: "danger",
                        onClick: () => onTagDel(index)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (item.isLocation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(BaseCascader), {
                  style: {"width":"100%"},
                  multiple: "",
                  options: _unref(addressData),
                  clearable: "",
                  "collapse-tags": ""
                }, null, 8, ["options"])
              ]))
            : (Array.isArray(item.childList))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childList, (tag, tagIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tag-value",
                      key: tag.id
                    }, [
                      _createElementVNode("p", null, _toDisplayString(tag.name), 1),
                      (tag.allowDelete && _unref(isOwnPublish))
                        ? (_openBlock(), _createBlock(_unref(BaseButton), {
                            key: 0,
                            disabled: 
                tag.allowDelete == 1 ||
                item.childList.length <=
                  (item.source === _unref(TAG_SOURCE_SYSTEM) ? 0 : 1)
              ,
                            link: "",
                            onClick: ($event: any) => (onTagValueDel(item.childList, tagIndex))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 删除 ")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})